const Joi = require('joi')
const fields = require('../fields')

const paginationSchema = Joi.object({
    limit: Joi.number().integer().min(5).max(50).required(),
    page: fields.integerAboveZeroField.required(),
})

module.exports = paginationSchema